import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import {
  Button,
  Paper,
  TextField,
} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import { styled } from '@material-ui/core/styles';

const Container = styled(Paper)({
  margin: 20,
  padding: 20,
  display: 'flex',
  justifyContent: 'space-evenly',
});

const ProspectDetailsControls = ({
  endDate,
  handleProspectDetailsSubmit,
  isActionLoading,
  prospectId,
  startDate,
}) => {
  const [pickerStartDate, setPickerStartDate] = useState(startDate);
  const [pickerEndDate, setPickerEndDate] = useState(endDate);
  const [inputProspectId, setInputProspectId] = useState(prospectId);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputProspectId(newValue);
  };

  return (
    <Container elevation={3}>
      <DatePicker
        label="Start Date"
        value={pickerStartDate}
        onChange={setPickerStartDate}
        autoOk
        format="MM/dd/yyyy"
      />
      <DatePicker
        label="End Date"
        value={pickerEndDate}
        onChange={setPickerEndDate}
        autoOk
        format="MM/dd/yyyy"
      />
      <TextField
        defaultValue={prospectId}
        label="Prospect Id"
        onChange={handleInputChange}
      />
      <Button
        disabled={isActionLoading}
        onClick={() => handleProspectDetailsSubmit({
          startDate: pickerStartDate,
          endDate: pickerEndDate,
          prospectId: inputProspectId,
        })}
        variant="contained"
      >
        Get System Failures
      </Button>
    </Container>
  );
};

ProspectDetailsControls.propTypes = {
  endDate: PropTypes.instanceOf(DateTime).isRequired,
  handleProspectDetailsSubmit: PropTypes.func.isRequired,
  isActionLoading: PropTypes.bool.isRequired,
  prospectId: PropTypes.string.isRequired,
  startDate: PropTypes.instanceOf(DateTime).isRequired,
};

export default ProspectDetailsControls;
